export const ResponsiveBreakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const

export type ResponsiveBreakpointsType = keyof typeof ResponsiveBreakpoints

export const UIState = {
  DEFAULT: 'default',
  LOADING: 'loading',
  ERROR: 'error',
  EMPTY: 'empty',
  SUCCESS: 'success',
} as const

export type UIStateType = typeof UIState[keyof typeof UIState]

export const ColorVariants = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info',
  AI: 'ai',
} as const

export type ColorVariantsType = typeof ColorVariants[keyof typeof ColorVariants]

export const FlexAlign = {
  START: 'start',
  CENTER: 'center',
  END: 'end',
  BETWEEN: 'between',
  AROUND: 'around',
  EVENLY: 'evenly',
} as const

export type FlexAlignType = typeof FlexAlign[keyof typeof FlexAlign]

export const MotionAnimations = {
  fade: {
    initial: {
      opacity: 0,
    },
    enter: {
      opacity: 1,
      transition: {
        duration: 300,
      },
    },
    leave: {
      opacity: 0,
    },
  },
  slideLeft: {
    initial: {
      x: 440,
    },
    enter: {
      x: 0,
      transition: {
        duration: 300,
      },
    },
    leave: {
      x: 440,
      transition: {
        duration: 300,
      },
    },
  },
} as const

export type MotionAnimationsType = keyof typeof MotionAnimations
